<template>
  <Modal :modal="mfaDisableModalRef" :steps="[{ component: MfaDisableContent, id: 'mfa-disable' }]" />
</template>

<script lang="ts" setup>
import MfaDisableContent from '@/features/auth/components/mfa-disable-modal/mfa-disable-content/mfa-disable-content.vue'
import Modal from '@/features/ui/components/modal/modal.vue'
import { selectGetMfaDisableModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'

const mfaDisableModalRef = selectGetMfaDisableModal(modalsStore)
</script>
